<template>
    <div class="h-screen w-screen bg-gray-100 flex items-center">
        <div class="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
            <div class="max-w-md">
                <div class="text-5xl font-dark font-bold">404 Not Found</div>
                <p class="text-2xl md:text-3xl font-light leading-normal mt-4">
                    ページが見つかりませんでした
                </p>
                <p class="mt-2 mb-8">
                    恐れ入りますが、トップページから再度お試しください。
                </p>
                <router-link
                    to="/"
                    class="px-4 inline py-2 text-sm font-medium leading-5 shadow text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-blue bg-blue-600 active:bg-blue-600 hover:bg-blue-700">
                    トップページに戻る
                </router-link>
            </div>
            <div class="max-w-lg">
                <CatSVG/>
            </div>
        </div>
    </div>
</template>

<script>
import CatSVG from "../../parts/CatSVG";
export default {
    name: "NotFound",
    components: {CatSVG},
    head: {
        title: {
            inner: '404 Not Found'
        }
    }
}
</script>

<style scoped>
.cls-1 {
    fill: #d6b49a;
}

.cls-1, .cls-10, .cls-11, .cls-13, .cls-14, .cls-15, .cls-17, .cls-2, .cls-4, .cls-5, .cls-6 {
    stroke: #000;
}

.cls-1, .cls-11, .cls-13, .cls-14, .cls-16, .cls-8 {
    stroke-linecap: round;
    stroke-linejoin: round;
}

.cls-1, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {
    stroke-width: 3px;
}

.cls-2 {
    fill: #020202;
}

.cls-10, .cls-12, .cls-15, .cls-17, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {
    stroke-miterlimit: 10;
}

.cls-3 {
    fill: #818181;
}

.cls-12, .cls-16, .cls-3, .cls-7, .cls-8, .cls-9 {
    stroke: #191818;
}

.cls-4 {
    fill: #dcdbda;
}

.cls-5 {
    fill: #4ea7f1;
}

.cls-14, .cls-6 {
    fill: #f8f3ed;
}

.cls-16, .cls-7 {
    fill: #333;
}

.cls-13, .cls-8 {
    fill: none;
}

.cls-9 {
    fill: #f8f59c;
}

.cls-10, .cls-11 {
    fill: #f3d2c9;
}

.cls-15 {
    fill: #8bb174;
}

.cls-17 {
    fill: #da4e22;
}
</style>
